import { memo } from 'react';
import { Box } from '@mui/joy';

const EditorStatusContainer = () => {
  return <Box id="editor-status-portal" />;
};

export default memo(EditorStatusContainer);
